"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Hover = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Hover, _Component);

  var _super = _createSuper(Hover);

  function Hover(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Hover);
    _this = _super.call(this, props);
    _this.state = {
      isHovering: false
    };
    return _this;
  }

  (0, _createClass2.default)(Hover, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      return (0, _preact.h)("div", {
        className: "hoverable",
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            isHovering: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            isHovering: false
          });
        }
      }, props.children, state.isHovering ? props.hoverComponent : null);
    }
  }]);
  return Hover;
}(_preact.Component);

var _default = Hover;
exports.default = _default;